<template>
  <li>
    <div v-if="rssItem.publishedDate.length == 4" class="datum rssitemdatum">
      {{ rssItem.publishedDate }}
    </div>
    <div class="rssitemlank">
      <a v-if="rssItem.url" :href="rssItem.url">
        <SistaOrdet
          :text="rssItem.title"
          :arrowToLeft="$arrowToLeft"
        ></SistaOrdet>
      </a>
    </div>
    <div class="rssitemdatum" v-if="rssItem.publishedDate.length > 4">
      <span class="iconwrapper">
        <Icon :type="'clock-o'"></Icon>
      </span>
      <span v-if="rssItem.eventDate" class="datum">
        {{ rssItem.eventDate }}
      </span>
      <span v-else-if="rssItem.applyByDate" class="datum">
        {{ $ansokSenastText }} {{ rssItem.applyByDate }}
      </span>
      <span v-else class="datum">
        {{ $publiceradText }}: {{ rssItem.publishedDate }}
      </span>
    </div>
    <div v-if="rssItem.creator">
      {{ rssItem.creator }}
    </div>
    <p v-else-if="rssItem.summary" v-html="rssItem.summary"></p>
  </li>
</template>

<script>
import Icon from "common/js/vue/image/icon.vue";
import SistaOrdet from "common/js/vue/helpers/sistaordet.vue";

export default {
  name: "RssItem",
  props: {
    rssItem: Object,
  },
  components: {
    Icon,
    SistaOrdet,
  },
};
</script>
